"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyDev_legend_elements = exports.Modal_creation_view_unitary_from_data = exports.SankeyDevBannerUnit = exports.modal_unitary_sankey_sector_node = exports.CreateViewNodeUnitary = exports.SankeyDev_link_text = exports.context_node_view_node_unitary = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_multi_select_component_1 = require("react-multi-select-component");
const fa_1 = require("react-icons/fa");
const fa_2 = require("react-icons/fa");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_folder_tree_1 = __importDefault(require("react-folder-tree"));
const d3 = __importStar(require("d3"));
const d3_textwrap_1 = require("d3-textwrap");
const react_2 = require("@chakra-ui/react");
const SankeyDevLayout_1 = require("./SankeyDevLayout");
const SankeyUtils_1 = require("open-sankey/dist/configmenus/SankeyUtils");
const FunctionOSTyped_1 = require("./FunctionOSTyped");
// Sankey Icons imports
const ListIcons = __importStar(require("sankeyicons/dist/icons/lib_of_icons.json"));
// MFASankey imports
const SankeyTrade_1 = require("afmsankey/dist/src/lib/SankeyTrade");
const SankeyPlusViews_1 = require("sankeyanimation/dist/src/SankeyPlusViews");
const SankeyMenuTop_1 = require("open-sankey/dist/topmenus/SankeyMenuTop");
const SankeyMenuConfigurationNodes_1 = require("open-sankey/dist/configmenus/SankeyMenuConfigurationNodes");
const SankeyPersistence_1 = require("open-sankey/dist/dialogs/SankeyPersistence");
const logo_unit_process_transfo = react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 1000 1000" },
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: "M 5.9497609,925.95372 C -4.5505643,898.59029 174.15641,385.43615 207.7775,346.40863 c 15.11437,-17.54486 44.31129,-26.22296 88.22545,-26.22296 60.24819,0 64.36204,-2.37881 50.12343,-28.98395 -34.65058,-64.74517 -4.1459,-170.55878 62.65945,-217.351077 18.36384,-12.862528 59.53485,-23.386413 91.49116,-23.386413 114.6541,0 198.53078,139.75294 144.48545,240.73749 -14.20756,26.5471 -10.11306,29.00324 48.69973,29.21341 35.31627,0.12593 72.75035,5.64955 83.18679,12.27401 24.6669,15.65717 227.23974,572.12519 217.5062,597.49016 -5.85902,15.26824 -110.04595,19.35647 -493.29195,19.35647 -428.177117,0 -486.938597,-2.79993 -494.9134491,-23.58205 z M 959.96469,913.28941 c 0,-3.45253 -43.82976,-126.14482 -97.39944,-272.64964 -53.56969,-146.50481 -97.39939,-268.42617 -97.39939,-270.93639 0,-2.51028 -47.20129,-4.56409 -104.8917,-4.56409 -110.0788,0 -123.20273,-8.75297 -76.49805,-51.02008 62.3297,-56.40765 44.96468,-173.27409 -31.63209,-212.88383 C 429.11754,37.615914 316.99725,196.72961 405.53726,309.29 c 16.48298,20.95469 29.96905,42.09317 29.96905,46.97435 0,4.88124 -46.21242,8.87494 -102.69428,8.87494 H 230.11774 L 138.0132,620.99887 C 87.355715,761.72162 45.908666,886.46785 45.908666,898.21258 c 0,18.0157 71.449614,21.35416 457.027984,21.35416 251.36543,0 457.02804,-2.82481 457.02804,-6.27733 z M 332.2502,664.82976 c 51.31553,-74.17337 102.68186,-134.86069 114.14741,-134.86069 24.56551,0 24.22186,0.641 -82.33,153.59135 -44.49571,63.87157 -90.85011,116.13011 -103.00982,116.13011 -14.21486,0 11.20386,-48.15104 71.19241,-134.86077 z m 49.22254,113.64977 c -4.47668,-11.66609 -5.95082,-40.32401 -3.27585,-63.68429 4.09089,-35.72541 11.74597,-42.47322 48.18406,-42.47322 56.85567,0 80.84917,37.13689 57.33566,88.74349 -19.55758,42.92415 -87.98262,54.57822 -102.24387,17.41402 z m 69.0181,-46.21938 c 0,-38.25773 -20.45211,-49.99828 -37.9048,-21.75923 -12.46509,20.16899 2.339,59.22054 22.44998,59.22054 8.50016,0 15.45482,-16.85761 15.45482,-37.46131 z m 164.82976,52.44582 c 0,-8.2415 13.48606,-14.98451 29.96906,-14.98451 26.38037,0 29.96906,-9.98971 29.96906,-83.42467 0,-76.60558 -2.44966,-82.64715 -29.96906,-73.91283 -40.22052,12.76549 -38.11612,-15.071 3.33415,-44.10393 62.096,-43.49373 71.58848,-31.68495 71.58848,89.05748 0,102.39424 2.66391,112.38395 29.96901,112.38395 16.48299,0 29.96906,6.74301 29.96906,14.98451 0,8.24149 -37.08669,14.98456 -82.41488,14.98456 -45.32819,0 -82.41488,-6.74307 -82.41488,-14.98456 z M 231.6275,643.61876 c -4.47669,-11.66603 -5.95083,-40.32393 -3.27586,-63.68421 4.09089,-35.72547 11.74598,-42.47322 48.18406,-42.47322 56.85569,0 80.84919,37.13683 57.33565,88.74347 -19.55757,42.92415 -87.98262,54.57816 -102.24385,17.41396 z m 69.01809,-46.21937 c 0,-38.25772 -20.45211,-49.99822 -37.90479,-21.75922 -12.4651,20.16899 2.33899,59.22053 22.44998,59.22053 8.50015,0 15.45481,-16.85754 15.45481,-37.46131 z M 435.50631,290.21666 c -58.20116,-58.20119 -20.37983,-164.8298 58.46537,-164.8298 85.65086,0 127.30456,122.98327 58.07669,171.47235 -44.82294,31.39521 -80.54006,29.35943 -116.54206,-6.64255 z m 104.2949,-36.74224 c 37.96518,-45.74527 -23.70748,-118.92546 -68.73283,-81.55773 -21.3863,17.74903 -27.98661,75.92696 -10.58785,93.32576 17.28971,17.28964 60.52889,10.87471 79.32068,-11.76803 z" })));
// Return button in context menu of node to create a unitary view with the contextualised node
const context_node_view_node_unitary = (applicationContext, dict_variable_application_data, contextMenu) => {
    var _a;
    const { t } = applicationContext;
    if (dict_variable_application_data.master_data === undefined) {
        dict_variable_application_data.master_data = JSON.parse(JSON.stringify(dict_variable_application_data.data));
    }
    const { master_data, set_master_data, data, set_data, set_view, display_nodes, display_links } = dict_variable_application_data;
    const { ref_setter_contextualised_node, ref_contextualised_node } = contextMenu;
    // Search if master data has view with unitary sankey
    const has_unitary_view = master_data && ((_a = master_data.view) === null || _a === void 0 ? void 0 : _a.filter(v => {
        if (v.view_data.diff !== undefined) {
            return v.view_data.diff.filter(vo => vo.path.includes('unitary_node')).length > 0;
        }
        else {
            return v.view_data.unitary_node.length > 0;
        }
    }).length) > 0;
    // Create a function that filter view to know if they are a unitary view
    // It detect if the view has unitary_node wich is a variable used in unitary sankey
    const is_unitary_view = (v) => {
        if (v.view_data.diff !== undefined) {
            return v.view_data.diff.filter(vo => vo.path.includes('unitary_node')).length > 0;
        }
        else {
            return v.view_data.unitary_node.length > 0;
        }
    };
    // Button to create un unitary sankey and add it to an existing unitary view
    // (/!\ for now it is unstable to add a unitary sankey to an already existing unitary view)
    const dropdown_c_n_explore_node_add_to_view = react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('view.in_existing')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, master_data ? master_data.view.filter(v => is_unitary_view(v)).map(v => {
            return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light', onClick: () => {
                    (0, exports.CreateViewNodeUnitary)(t, data, set_data, master_data, set_master_data, ref_contextualised_node.current, set_view, display_nodes, display_links, true, v.id);
                    ref_setter_contextualised_node.current(undefined);
                } }, v.nom);
        }) : react_1.default.createElement(react_1.default.Fragment, null)));
    // Button to create un unitary sankey and add it to a new unitary view
    const dropdown_c_n_explore_node = react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" },
            t('view.unit_node'),
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, "Dev")),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light', onClick: () => {
                    (0, exports.CreateViewNodeUnitary)(t, data, set_data, master_data, set_master_data, ref_contextualised_node.current, set_view, display_nodes, display_links, true);
                } }, t('view.in_new')),
            has_unitary_view ? dropdown_c_n_explore_node_add_to_view : react_1.default.createElement(react_1.default.Fragment, null)));
    if (data.unitary_node && data.unitary_node.length === 0) {
        return dropdown_c_n_explore_node;
    }
    else if (data.unitary_node && data.unitary_node.length > 0) {
        return react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
                data.unitary_node = [];
                set_data(Object.assign({}, data));
            }, variant: 'light' },
            t('view.to_normal_view'),
            " ");
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.context_node_view_node_unitary = context_node_view_node_unitary;
// Function used only in unitary sankey
// It return the value of links formated
// By default it in percent compared to the sum of link (input or output)
// If the unitary node is a sector and we chose some links as reference then the value is normalised to the sum of selected link
// (Exemple : we select 1 link of value 10 then all link value are noramlised by 1/10  )
const SankeyDev_link_text = (data, d, GetLinkValue, t) => {
    const data_dev = data;
    const k_n_u = data_dev.unitary_node.filter(kn => kn === d.idTarget || kn === d.idSource)[0];
    const link_ref = Object.keys(data_dev.process_transfo_ref).filter(k => k === k_n_u && data_dev.process_transfo_ref[k].length > 0).map(k => k);
    const link_unit = (0, FunctionOSTyped_1.ReturnValueLink)(data, d, 'label_unit');
    if (GetLinkValue === undefined) {
        return;
    }
    const the_link_value = GetLinkValue(data, d.idLink);
    // Si le flux n'est pas relié à un noeud unitaire alors sa valeur est de 100%
    if (k_n_u === undefined) {
        return '100 %';
    }
    else if (data_dev.unit_link_value_display === 'percent' ||
        (data_dev.unit_link_value_display === 'normalize' &&
            !(data.nodes[k_n_u].tags['Type de noeud'] &&
                data.nodes[k_n_u].tags['Type de noeud'].includes('secteur') &&
                link_ref.length > 0))) {
        // Si unit_link_value_display est à 'percent' 
        // ou bien qu'il est à 'normalize' mais qu'il ne remplie pas les critères pour êtres un process de transformation 
        // alors sa valeur est en % par rapport à la somme des flux entrant ou sortant
        // Calcul le total des flux entrants entre eux et de même pour les sortants
        const total_io = calc_total_input_output(data_dev.nodes[k_n_u], data_dev, GetLinkValue);
        if (data.show_structure === 'structure') {
            return;
        }
        if (data.show_structure === 'data') {
            if (the_link_value.extension.data_value) {
                return the_link_value.extension.data_value;
            }
            else {
                return;
            }
        }
        if (!isNaN(the_link_value.value)) {
            // Return value of link in %
            // If the value has decimal, then fix it to 2 decimal
            const val = (data_dev.unitary_node.includes(d.idSource) ? ((the_link_value.value / total_io[1]) * 100) : ((the_link_value.value / total_io[0]) * 100));
            return (Number.isInteger(val) ? Math.round(val) : (val).toFixed(2)) + ' %';
        }
        else {
            return '0 %';
        }
    }
    else if (data_dev.unit_link_value_display === 'normalize' &&
        data.nodes[k_n_u].tags['Type de noeud'] &&
        data.nodes[k_n_u].tags['Type de noeud'].includes('secteur') &&
        link_ref.length > 0) {
        // Si le flux est relié à un noeud unitaire et que ce noeud est un secteur
        // alors 1 ou + flux peuvent être des références et sont utilisés pour normalisé les valeurs
        // Les flux sont normalisé selont la somme des flux de référence
        let sum = 0;
        data_dev.process_transfo_ref[k_n_u].forEach(p => {
            sum += GetLinkValue(data, p).value;
        });
        const part_value = (the_link_value.value / sum);
        const formated_value = (Number.isInteger(part_value) ? Math.round(part_value) : (part_value).toFixed(3));
        return formated_value + link_unit;
    }
    else if (data_dev.unit_link_value_display === 'value') {
        // le noeud unitaire est un secteur mais qu'il n'a pas de flux de référence ou qu'il n'ai pas l'étiquette 'Type de noeud'
        // alors il les affiche normalement
        return (0, FunctionOSTyped_1.LinkText)(data, d, GetLinkValue, t);
    }
};
exports.SankeyDev_link_text = SankeyDev_link_text;
const CreateViewNodeUnitary = (t, data, set_data, master_data, set_master_data, unitary_node, set_view, display_nodes, display_links, from_zdd, view_name = '') => {
    const new_unitary_sankey = JSON.parse(JSON.stringify(data));
    const link_visible_onsankey = from_zdd ? (0, FunctionOSTyped_1.LinkVisibleOnSvg)() : Object.values(new_unitary_sankey.links).map(l => l.idLink);
    const n_link_s = Object.values(new_unitary_sankey.links).filter(l => unitary_node.inputLinksId.includes(l.idLink) && link_visible_onsankey.includes(l.idLink)).map(l => l.idSource);
    const n_link_t = Object.values(new_unitary_sankey.links).filter(l => unitary_node.outputLinksId.includes(l.idLink) && link_visible_onsankey.includes(l.idLink)).map(l => l.idTarget);
    const nodes_visible_to_keep = Object.fromEntries(Object.entries(new_unitary_sankey.nodes).filter(ne => {
        var _a, _b;
        if (ne[1].local && ((_a = ne[1].local) === null || _a === void 0 ? void 0 : _a.local_aggregation) !== undefined) {
            (_b = ne[1].local) === null || _b === void 0 ? true : delete _b.local_aggregation;
        }
        // Keep only the node contextualised,
        // or the node linked to it
        return ne[1].idNode === unitary_node.idNode || ((n_link_s.includes(ne[1].idNode) || n_link_t.includes(ne[1].idNode)));
    }).map(n => n));
    // If we create a unitary sankey from the menu 'Unit.' then we have to set the level tags to allow the contextualied node to be displayed
    // (In contrary to when we create a unitary sankey from the drawing area, because the levelTags are automatically correct since we selected a visible node)
    if (!from_zdd && unitary_node.dimensions) {
        // Set the level tags to aggreagation level of the contextualised node (only if we select the node from the menu Unit.)
        const key_level_tag = Object.keys(new_unitary_sankey.levelTags).filter(klt => klt !== 'Primaire').length > 0 ? Object.keys(new_unitary_sankey.levelTags).filter(klt => klt !== 'Primaire') : Object.keys(new_unitary_sankey.levelTags);
        // Then keep only the level tags that the contextualised node has 
        const key_level_tag_node = key_level_tag.filter(k => unitary_node.tags[k] ? unitary_node.tags[k].length > 0 : false);
        // So now we run through all levetTags that the contextualised node has and set them so we display the node selected at the creation of the unitary sankey
        key_level_tag_node.forEach(klt => Object.values(new_unitary_sankey.levelTags[klt].tags).forEach(kltt => kltt.selected = false));
        Object.entries(unitary_node.tags).filter(en => key_level_tag_node.includes(en[0]) && en[1].length > 0).forEach(en => Object.entries(new_unitary_sankey.levelTags[en[0]].tags).forEach(kltt => {
            kltt[1].selected = (kltt[0] === en[1][en[1].length - 1]);
        }));
    }
    // Get type of the unitary node (it can be 'secteur','produit','échange' or undefined)
    const type_node = (unitary_node.tags['Type de noeud'] !== undefined && unitary_node.tags['Type de noeud'].length > 0) ? (unitary_node.tags['Type de noeud'][0]) : undefined;
    // Get all the parents & sons (aggregation speaking) of all_nodes_in_unitary_sankey
    const center_sankey_node_unitary = [unitary_node.idNode];
    let aggregate_nodes_to_keep = [];
    Object.entries(nodes_visible_to_keep).filter(ne => ne[1].idNode !== unitary_node.idNode).forEach(ne => {
        // If the unitary node is a product then import/export linked to it are put to trade_close:false (import/export are visible nodes)
        const type_node_ne = (ne[1].tags['Type de noeud'] !== undefined && ne[1].tags['Type de noeud'].length > 0) ? (ne[1].tags['Type de noeud'][0]) : undefined;
        // If the node is an import/export, then we change it variable trade_close to false
        if (type_node === 'produit' && type_node_ne === 'echange') {
            const n_conv = ne[1];
            n_conv.trade_close = false;
            ne[1].name = ne[1].name.includes('Importations') ? 'Importations' : 'Exportations';
        }
        const parent = return_aggregation_tree_of_node(ne[1], data.nodes);
        aggregate_nodes_to_keep = [...aggregate_nodes_to_keep, ...JSON.parse(JSON.stringify(parent))];
    });
    aggregate_nodes_to_keep = [...new Set(aggregate_nodes_to_keep)];
    if (!from_zdd) {
        // If we select the contextualised node from the menu then we Desaggregate all nodes linked to it
        // We desagregate them by setting their local_aggreagation to true if they're leaf else it's set at false (except the unitary node)
        aggregate_nodes_to_keep
            .filter(kn => !center_sankey_node_unitary.includes(kn))
            .map(kn => {
            // First put all nodes has not visible (local_aggragation to false put them invisible)
            const loc = new_unitary_sankey.nodes[kn].local;
            loc ? loc.local_aggregation = false : new_unitary_sankey.nodes[kn].local = { local_aggregation: false };
            return kn;
        })
            .filter(kn => {
            // Then filter to keep only the leaf
            return is_leaf(new_unitary_sankey, kn);
        }).forEach(kn => {
            // Finally put local_aggragation value of all nodes that are leaf and linked to the unitary node to true
            const loc = new_unitary_sankey.nodes[kn].local;
            loc ? loc.local_aggregation = true : new_unitary_sankey.nodes[kn].local = { local_aggregation: true };
        });
    }
    // Add nodes not visible but that have an aggregation link to one visible
    const all_nodes_in_unitary_sankey = JSON.parse(JSON.stringify(nodes_visible_to_keep));
    aggregate_nodes_to_keep.forEach(kn => {
        all_nodes_in_unitary_sankey[kn] = new_unitary_sankey.nodes[kn];
    });
    const key_of_nodes_in_unitary_sankey = Object.values(all_nodes_in_unitary_sankey).map(n => n.idNode);
    // Get key of link that are connected to 2 nodes of the nodes to keep
    const n_link = [];
    Object.values(new_unitary_sankey.links).filter(l => key_of_nodes_in_unitary_sankey.includes(l.idSource) && key_of_nodes_in_unitary_sankey.includes(l.idTarget)).forEach(l => {
        n_link.push(l.idSource);
        n_link.push(l.idTarget);
        if (center_sankey_node_unitary.includes(l.idTarget)) {
            (0, FunctionOSTyped_1.AssignNodeValueToCorrectVar)(all_nodes_in_unitary_sankey[l.idSource], 'label_horiz', 'left', false);
        }
        else if (center_sankey_node_unitary.includes(l.idSource)) {
            (0, FunctionOSTyped_1.AssignNodeValueToCorrectVar)(all_nodes_in_unitary_sankey[l.idTarget], 'label_horiz', 'right', false);
        }
    });
    const links_to_keep = Object.fromEntries(Object.entries(new_unitary_sankey.links).filter(l => n_link.includes(l[1].idSource) && n_link.includes(l[1].idTarget)).map(l => {
        l[1].value = (0, FunctionOSTyped_1.GetLinkValue)(new_unitary_sankey, l[1].idLink);
        l[1].colorTag = 'no_colormap';
        (0, FunctionOSTyped_1.AssignLinkLocalAttribute)(l[1], 'left_horiz_shift', 0.04999999999999999);
        (0, FunctionOSTyped_1.AssignLinkLocalAttribute)(l[1], 'right_horiz_shift', 0.95);
        (0, FunctionOSTyped_1.AssignLinkLocalAttribute)(l[1], 'recycling', false);
        return l;
    }));
    const k_l_t_k = Object.keys(links_to_keep);
    // Key levelTag
    const k_level_tag = Object.keys(new_unitary_sankey.levelTags);
    Object.entries(all_nodes_in_unitary_sankey).map(n => {
        // Filter output/input link id by removing link no longer present in data
        n[1].outputLinksId = n[1].outputLinksId.filter(ol => k_l_t_k.includes(ol));
        n[1].inputLinksId = n[1].inputLinksId.filter(il => k_l_t_k.includes(il));
        // Keep tag that refernece levelTag && tag of group tag 'Type de noeud'
        n[1].tags = Object.fromEntries(Object.entries(n[1].tags).filter(nt => nt[0] === 'Type de noeud' || k_level_tag.includes(nt[0])));
        n[1].colorTag = 'no_colormap';
        n[1].colorParameter = 'local';
        return n;
    });
    // Run throught all node to search if it is at the same time a source and a target for unitary_node
    // If that the case we duplicate the node and add a prefix (1 for the source and 1 for the target) 
    Object.entries(all_nodes_in_unitary_sankey).filter(n => {
        const is_src = Object.values(links_to_keep).filter(l => l.idTarget === unitary_node.idNode && l.idSource === n[1].idNode).length > 0;
        const is_trgt = Object.values(links_to_keep).filter(l => l.idSource === unitary_node.idNode && l.idTarget === n[1].idNode).length > 0;
        return is_trgt && is_src;
    }).forEach(n => {
        let k_clone_of_node = JSON.parse(JSON.stringify(n[0]));
        const clone_of_node = JSON.parse(JSON.stringify(n[1]));
        k_clone_of_node += '_Amont';
        clone_of_node.idNode = k_clone_of_node;
        clone_of_node.name = clone_of_node.name + ' - Amont';
        // Change link in amont to link it to the clone
        const original_link_src = Object.values(links_to_keep).filter(l => l.idTarget === unitary_node.idNode && l.idSource === n[1].idNode)[0];
        original_link_src.idSource = k_clone_of_node;
        // Change original node name
        n[1].name += ' - Aval';
        // Add the clone
        all_nodes_in_unitary_sankey[k_clone_of_node] = clone_of_node;
    });
    const nodes_to_keep = all_nodes_in_unitary_sankey;
    // Create string containing datatag info for zdt
    let DT_info = '';
    // Add additional info concerning the dataTag at the moment of the creation of the unitary sankey
    // because once the unitary sankey is created, we delete the datatags
    const data_tags = Object.assign({}, new_unitary_sankey.dataTags);
    Object.entries(data_tags).forEach(tag_group => {
        const intro_group_data_tags = ' : ' + Object.values(tag_group[1].tags).filter(t => t.selected).map(t => t.name).join(', ');
        DT_info += '<p>' + tag_group[1].group_name + intro_group_data_tags + '</p>';
    });
    // Normalize data
    new_unitary_sankey.nodeTags = Object.fromEntries(Object.entries(new_unitary_sankey.nodeTags).filter(nt => nt[0] === 'Type de noeud').map(nt => nt));
    new_unitary_sankey.fluxTags = {};
    new_unitary_sankey.dataTags = {};
    new_unitary_sankey.labels = {};
    new_unitary_sankey.colorMap = 'no_colormap';
    new_unitary_sankey.linkZIndex = new_unitary_sankey.linkZIndex.filter(lz => k_l_t_k.includes(lz)).map(l => l);
    new_unitary_sankey.nodes = nodes_to_keep;
    new_unitary_sankey.h_space = 300;
    new_unitary_sankey.links = links_to_keep;
    // If the data from which we create a unitary view from doesn't have 'unit_link_value_display' then we add it default value
    if (new_unitary_sankey.unit_link_value_display === undefined) {
        new_unitary_sankey.unit_link_value_display = 'percent';
    }
    // attributes are standardized
    // Also delete node that doesn't have link attached to it
    const to_delete = Object.entries(new_unitary_sankey.nodes)
        .map(node => {
        node[1].position = 'absolute';
        return node;
    }).filter(n => n[1].outputLinksId.length === 0 && n[1].inputLinksId.length === 0).map(n => n[0]);
    to_delete.forEach(nid => delete new_unitary_sankey.nodes[nid]);
    let scale = d3.scaleLinear()
        .domain([0, +new_unitary_sankey.user_scale])
        .range([0, 100]);
    let inv_scale = d3.scaleLinear()
        .domain([0, 100])
        .range([0, new_unitary_sankey.user_scale]);
    // Get a formated version unitary_node, 
    // in this variable output/input links id of the unitary_node are filtered according to the new unitary sankey
    // Notably usefull for compute_auto_unitary_sankey that run throught the variables input/output links id of the contextualised node,
    // so it could have accessed link id in inputLinksId of unitary_node that are no longer present in new_unitary_sankey
    const formated_unitary_node = new_unitary_sankey.nodes[unitary_node.idNode];
    // links attributes are standardized
    Object.values(new_unitary_sankey.links).forEach(link => {
        link.local = {};
    });
    // Some preparation of nodes attributes
    // If it's not a unitary node we don't show the shape
    // else we format it text and add an icon according to it node type
    if (new_unitary_sankey.icon_catalog === undefined) {
        new_unitary_sankey.icon_catalog = {};
    }
    Object.values(new_unitary_sankey.nodes).forEach(n => {
        delete n.x_label;
        delete n.y_label;
        n.y += 200;
        (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'label_background', false);
        (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'font_size', 20);
        if (n.idNode !== unitary_node.idNode) {
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'shape_visible', false);
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'bold', false);
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'uppercase', false);
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'node_width', 1);
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'label_vert', 'middle');
            if ((0, FunctionOSTyped_1.ReturnValueNode)(data, n, 'label_box_width') <= 150) {
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'label_box_width', 150);
            }
            // Change the label_box_width of import/export nodes after ArrangeTrade because it reset it width at 300px ( and we changed their names to be shorter)
            const type_node_ne = (n.tags['Type de noeud'] !== undefined && n.tags['Type de noeud'].length > 0) ? (n.tags['Type de noeud'][0]) : undefined;
            if (type_node === 'produit' && type_node_ne === 'echange') {
                // Since originally the import/export nodes label is like : 'name of the node' - 'the group name of the exchange' - 'import or export', 
                // the label_box_width is very large to contain it in 1 line and now we just set the name Import or Export to those node linked to the unitary node,
                // We re adjust the label_box_width so when we create the ZDT it take the correct value of node label width so the ZDT is not too large
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'label_box_width', 150);
            }
        }
        else {
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'bold', true);
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'uppercase', true);
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'label_vert', 'bottom');
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'label_horiz', 'middle');
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'node_width', 200);
            (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'label_box_width', 200);
            // Add an icon to the unitary node depending of it node type
            if (type_node === 'secteur') {
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'shape_visible', false);
                n.iconName = 'node_industrie';
                n.iconColor = 'black';
                n.iconVisible = true;
                n.is_image = false;
                n.image_src = '';
                delete n.iconViewBox;
                new_unitary_sankey.icon_catalog['node_industrie'] = ListIcons.waste.industry;
            }
            else if (type_node === 'produit') {
                (0, FunctionOSTyped_1.AssignNodeLocalAttribute)(n, 'shape_visible', false);
                n.iconName = 'node_market_process';
                n.iconColor = 'black';
                n.iconVisible = true;
                n.is_image = false;
                n.image_src = '';
                new_unitary_sankey.icon_catalog['node_market_process'] = ListIcons.waste.atom;
            }
        }
    });
    // Reposition visible node
    (0, SankeyTrade_1.ArrangeTrade)(new_unitary_sankey, scale);
    (0, SankeyDevLayout_1.compute_auto_unitary_sankey)(new_unitary_sankey, formated_unitary_node, new_unitary_sankey.h_space ? new_unitary_sankey.h_space : 200);
    // Recompute scale after the compute auto_sankey that reset user_scale
    scale = d3.scaleLinear()
        .domain([0, +new_unitary_sankey.user_scale])
        .range([0, 100]);
    inv_scale = d3.scaleLinear()
        .domain([0, 100])
        .range([0, new_unitary_sankey.user_scale]);
    // ======Add ZDT======
    // Get dimensions for labels
    // Get the node the most at left
    const min_x_node = Object.values(nodes_to_keep).filter(n => n.position === 'absolute' && (0, FunctionOSTyped_1.NodeDisplayed)(new_unitary_sankey, n)).sort((a, b) => {
        return (a.x) - (b.x);
    })[0];
    // Get widest label_box from nodes on the left side of the contexualised node 
    let widest_left_label_box = 0;
    Object.values(nodes_to_keep)
        .filter(n => n.position === 'absolute' && (0, FunctionOSTyped_1.NodeDisplayed)(new_unitary_sankey, n) && Object.values(new_unitary_sankey.links).filter(l => l.idSource === n.idNode && l.idTarget === unitary_node.idNode).length > 0)
        .forEach((n) => {
        const tmp = (0, FunctionOSTyped_1.ReturnValueNode)(new_unitary_sankey, n, 'label_box_width');
        widest_left_label_box = tmp > widest_left_label_box ? tmp : widest_left_label_box;
    });
    // Get widest label_box from nodes on the right side of the contexualised node 
    let widest_right_label_box = 0;
    Object.values(nodes_to_keep)
        .filter(n => {
        return n.position === 'absolute' && (0, FunctionOSTyped_1.NodeDisplayed)(new_unitary_sankey, n) && Object.values(new_unitary_sankey.links).filter(l => l.idTarget === n.idNode && l.idSource === unitary_node.idNode).length > 0;
    })
        .forEach((n) => {
        const tmp = (0, FunctionOSTyped_1.ReturnValueNode)(new_unitary_sankey, n, 'label_box_width');
        widest_right_label_box = tmp > widest_right_label_box ? tmp : widest_right_label_box;
    });
    // Substract widest_left_label_box to the min x so when we create the ZDT it take into account the label 
    const min_x = min_x_node.x - widest_left_label_box;
    // Get the node the most at top
    const min_y_node = Object.values(nodes_to_keep).filter(n => n.position === 'absolute' && (0, FunctionOSTyped_1.NodeDisplayed)(new_unitary_sankey, n)).sort((a, b) => {
        return (a.y) - (b.y);
    })[0];
    const min_y = min_y_node.y;
    let max_x = min_x;
    let max_y = min_y;
    Object.values(nodes_to_keep).filter(n => n.position === 'absolute' && (0, FunctionOSTyped_1.NodeDisplayed)(new_unitary_sankey, n)).forEach(n => {
        const boxX = n.x;
        const boxY = n.y;
        const res = (0, FunctionOSTyped_1.ComputeTotalOffsets)(inv_scale, n, new_unitary_sankey, display_nodes, display_links, FunctionOSTyped_1.TestLinkValue, undefined, FunctionOSTyped_1.GetLinkValue);
        const [total_offset_height_left, total_offset_height_right, total_offset_width_top, total_offset_width_bottom] = res;
        let node_size_s_height = Math.max(inv_scale((0, FunctionOSTyped_1.ReturnValueNode)(new_unitary_sankey, n, 'node_height')), total_offset_height_left, total_offset_height_right);
        let node_size_s_width = Math.max(inv_scale((0, FunctionOSTyped_1.ReturnValueNode)(new_unitary_sankey, n, 'node_width')), total_offset_width_top, total_offset_width_bottom);
        //Hauteur des noeuds
        if ((res[0] === 0 && res[1] === 0 && res[2] === 0 && res[3] === 0) || (new_unitary_sankey.show_structure === 'structure')) {
            node_size_s_height = inv_scale((0, FunctionOSTyped_1.ReturnValueNode)(new_unitary_sankey, n, 'node_height'));
            node_size_s_width = inv_scale((0, FunctionOSTyped_1.ReturnValueNode)(new_unitary_sankey, n, 'node_width'));
        }
        const boxW = scale(node_size_s_width);
        const boxH = scale(node_size_s_height);
        max_x = ((boxX + boxW) > max_x) ? (boxX + boxW) : max_x;
        max_y = ((boxY + boxH) > max_y) ? (boxY + boxH) : max_y;
    });
    // Add widest_right_label_box to the max x so when we create the ZDT it take into account the label of right nodes
    max_x += widest_right_label_box;
    // Info from data source in ZDT
    // customize the info to add in the zdt
    let content_zdt = '';
    let type_process = '';
    if (type_node === 'produit' || type_node === 'secteur') {
        if (type_node === 'produit') {
            type_process = 'Process de marché';
        }
        else {
            type_process = 'Process de transformation';
        }
    }
    else {
        type_process = t('view.template_unitary_zdt_content_of_node');
    }
    // Add the info to the zdt
    const name_view = (master_data.view && master_data.current_view && master_data.current_view !== 'none') ?
        master_data.view.filter(v => v.id === master_data.current_view)[0].nom :
        t('Menu.home');
    content_zdt += '<p class="ql-align-center" style="font-size:20px"><u>' + type_process + ' : <strong>' + unitary_node.name + '</strong></u></p>';
    content_zdt += '<p>' + t('view.template_unitary_zdt_content') + ' <strong>' + name_view + ' </strong></p>';
    content_zdt += DT_info;
    // Create the zdt
    const n_label = {
        idLabel: 'label_' + String(new Date().getTime()),
        title: 'Description',
        content: content_zdt,
        label_width: ((max_x - min_x)),
        label_height: ((max_y - min_y) + 150),
        color: 'white',
        color_border: 'black',
        opacity: 100,
        transparent_border: false,
        x: min_x,
        y: min_y - 100,
        is_image: false,
        image_src: ''
    };
    // Perform some configuration if the unitary go to a new view or an existing view
    if (view_name === '') {
        new_unitary_sankey.labels[n_label.idLabel] = n_label;
        // Add the contextualised node to list of explored nodes (to use in the process of LinkText)
        new_unitary_sankey.unitary_node = [...new_unitary_sankey.unitary_node, ...center_sankey_node_unitary];
        const new_id = 'view_' + String(new Date().getTime()) + String((0, SankeyUtils_1.GetRandomInt)(100));
        master_data.view.push({
            id: new_id,
            view_data: new_unitary_sankey,
            nom: t('view.default_unit_view_name') + unitary_node.name,
            details: '',
            heredited_attr_from_master: []
        });
        set_view(new_id);
        set_data(Object.assign({}, new_unitary_sankey));
    }
    else {
        // If the unitary sankey go to an existing view then we perform some ajustement :
        // - We change the id of links and nodes to avoid corruption of the other unitary sankey in the view
        // - We shift the explainatory ZDT  and new unitary sankey under the existing one
        // Search for the view to add the new exploration node
        let ind = -1;
        master_data.view.forEach((v, i) => {
            ind = (v.id === view_name) ? i : ind;
        });
        const data_view = (0, SankeyPlusViews_1.GetDataFromView)(master_data, master_data.view[ind].id);
        // =====Update data icon catalog=====
        Object.entries(new_unitary_sankey.icon_catalog).forEach(i => {
            data_view.icon_catalog[i[0]] = i[1];
        });
        // =====Update the ZDT to verticaly align it with the last one in the view=====
        const last_label_pos_in_view = Object.values(data_view.labels)[Object.values(data_view.labels).length - 1];
        n_label.x = last_label_pos_in_view.x;
        n_label.y = last_label_pos_in_view.y + last_label_pos_in_view.label_height + 5;
        // =====Update nodes & links=====
        // Create unique key to use in the suffix
        const unique_key = String(new Date().getTime());
        // Add a unique suffix to nodes & links in case we add node/link who have the same id of some in the view
        Object.entries(new_unitary_sankey.nodes).map(n => {
            n[0] = n[0] + '_' + unique_key;
            n[1].idNode = n[0];
            n[1].inputLinksId = n[1].inputLinksId.map(l => {
                const idSrc = new_unitary_sankey.links[l].idSource + '_' + unique_key;
                return idSrc + '---' + n[0];
            });
            n[1].outputLinksId = n[1].outputLinksId.map(l => {
                const idTrgt = new_unitary_sankey.links[l].idTarget + '_' + unique_key;
                return n[0] + '---' + idTrgt;
            });
            n[1].x -= (min_x - n_label.x);
            n[1].y -= (min_y - n_label.y) - 100;
            n[1].style = n[1].style + '_' + unique_key;
            Object.keys(n[1].tags).forEach(nkt => nkt = nkt + '_' + unique_key);
            if (n[1].dimensions) {
                Object.keys(n[1].dimensions).forEach(nd => nd = nd + '_' + unique_key);
            }
            return n;
        }).forEach(n => {
            data_view.nodes[n[0]] = n[1];
        });
        // Change idLink,idSource and idTarget of links to avoid corruption of existing links
        Object.entries(new_unitary_sankey.links).map(l => {
            l[1].idSource = l[1].idSource + '_' + unique_key;
            l[1].idTarget = l[1].idTarget + '_' + unique_key;
            l[0] = l[1].idSource + '---' + l[1].idTarget;
            l[1].idLink = l[0];
            l[1].style = l[1].style + '_' + unique_key;
            return l;
        }).forEach(l => {
            data_view.linkZIndex.push(l[1].idLink);
            data_view.links[l[0]] = l[1];
        });
        // Update style ID in case it has different value with the samez id
        Object.entries(new_unitary_sankey.style_node).forEach(ns => {
            data_view.style_node[ns[0] + '_' + unique_key] = ns[1];
        });
        Object.entries(new_unitary_sankey.style_link).forEach(ls => {
            data_view.style_link[ls[0] + '_' + unique_key] = ls[1];
        });
        // Update levelTags key so it doesn't interfer with other unitary node levelTags
        Object.entries(new_unitary_sankey.levelTags).forEach(lt => {
            data_view.levelTags[lt[0] + '_' + unique_key] = lt[1];
        });
        // =====Add the new ZDT=====
        data_view.labels[n_label.idLabel] = n_label;
        // =====Add the contextualised node to list of explored nodes (to use in the process of LinkText)=====
        const process_name_unitary_node = center_sankey_node_unitary.map(k => k + '_' + unique_key);
        data_view.unitary_node = [...data_view.unitary_node, ...process_name_unitary_node];
        if (data_view.unit_link_value_display === undefined) {
            data_view.unit_link_value_display = 'percent';
        }
        // ------------------------------------------------------------
        // =====Update the view=====
        // master_data.view[ind].view_data=new_unitary_sankey
        set_view(view_name);
        set_data(Object.assign({}, data_view));
    }
    // Save master data with the view we are currently working on updated
    set_master_data(Object.assign({}, master_data));
};
exports.CreateViewNodeUnitary = CreateViewNodeUnitary;
const calc_total_input_output = (n, data, GetLinkValue) => {
    const filtered_input_links = n.inputLinksId.filter(lid => {
        const node_to_test = data.nodes[data.links[lid].idSource];
        return (0, FunctionOSTyped_1.NodeDisplayed)(data, node_to_test);
    }).map(id => id);
    let total_input = 0;
    for (const i in filtered_input_links) {
        const val = GetLinkValue(data, filtered_input_links[i]).value;
        total_input += (!isNaN(val) && val !== '' ? val : 0);
    }
    const filtered_output_links = n.outputLinksId.filter(lid => {
        const node_to_test = data.nodes[data.links[lid].idTarget];
        return (0, FunctionOSTyped_1.NodeDisplayed)(data, node_to_test);
    }).map(id => id);
    let total_output = 0;
    for (const i in filtered_output_links) {
        const val = GetLinkValue(data, filtered_output_links[i]).value;
        total_output += (!isNaN(val) && val !== '' ? val : 0);
    }
    return [total_input, total_output];
};
// Return list of all parents and childrens of node 'n'
const return_aggregation_tree_of_node = (n, nodes) => {
    const siblings = [];
    return_aggregation_parents_of_node(n, nodes, siblings);
    return_aggregation_sons_of_node(n, nodes, siblings);
    return siblings;
};
const return_aggregation_parents_of_node = (n, nodes, found_fathers) => {
    if (n.dimensions) {
        Object.entries(n.dimensions).forEach(nd => {
            if (nd[1].parent_name !== undefined && nd[1].parent_name !== null && nd[0] !== 'Primaire') {
                if (!nodes[nd[1].parent_name]) {
                    // Sanity check. Not sure it should happen
                    return;
                }
                found_fathers.push(nd[1].parent_name);
                return_aggregation_parents_of_node(nodes[nd[1].parent_name], nodes, found_fathers);
            }
        });
    }
};
const return_aggregation_sons_of_node = ((n, nodes, found_sons) => {
    // Parcours tous les noeuds à la recherche des enfants de n (ne cherche pas les enfants de type import/export)
    Object.values(nodes).filter(nn => {
        return (nn.tags['Type de noeud'] !== undefined && nn.tags['Type de noeud'].length > 0) ? (!nn.tags['Type de noeud'].includes('echange')) : true;
    }).forEach(nn => {
        if (nn.dimensions) {
            // Si le noeud (nn) a pour parents le noeud que l'on recherche (n) alors on l'ajoute à found_sons puis recherche les enfants de ce noeud là (nn)
            Object.entries(nn.dimensions).forEach(nd => {
                var _a;
                if (((_a = nd[1]) === null || _a === void 0 ? void 0 : _a.parent_name) === n.idNode && nd[0] !== 'Primaire') {
                    found_sons.push(nn.idNode);
                    return_aggregation_sons_of_node(nn, nodes, found_sons);
                }
            });
        }
    });
});
const modal_unitary_sankey_sector_node = ({ data, set_data, display_nodes, dict_hook_ref_setter_show_dialog_components, t, GetLinkValue }) => {
    const [search_in_input_or_output, set_search_in_input_or_output] = (0, react_1.useState)('inputLinksId'); // useState not OK
    const [selected_node_to_configure, set_selected_node_to_configure] = (0, react_1.useState)(); // useState not OK
    const show_modal_edit_link_unitary_sankey = (0, react_1.useState)(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_modal_edit_link_reference_unitary.current = show_modal_edit_link_unitary_sankey[1];
    // Modale used to chose link as ref in the to unitary sankey view, those links come are linked to the unitary node
    // We can select multiple links but only if they're all input or output (we can't select some input links and output link to be reference a the same time)
    let selected_id = [];
    let option = [];
    // Search if the unitary node has the tag 'sector' from the group tag 'Type de noeud' 
    // so we can add a new way to display links value (normalize)
    const has_sector_ref_node_ins_unitary_view = data.unitary_node.length > 0 && data.unitary_node.filter(nid => data.nodes[nid].tags['Type de noeud'] && data.nodes[nid].tags['Type de noeud'].includes('secteur')).length > 0;
    if (data.unitary_node.length > 0) {
        if (selected_node_to_configure && selected_node_to_configure !== 'None') {
            selected_id = data.process_transfo_ref[selected_node_to_configure] ? data.process_transfo_ref[selected_node_to_configure].map(lidref => {
                const src_name = data.nodes[data.links[lidref].idSource].name;
                const trgt_name = data.nodes[data.links[lidref].idTarget].name;
                return { 'label': src_name + '--->' + trgt_name, 'value': lidref };
            }) : selected_id;
            option = data.nodes[selected_node_to_configure][search_in_input_or_output].filter(lid => (0, FunctionOSTyped_1.LinkVisible)(data.links[lid], data, display_nodes, GetLinkValue)).map(lid => {
                const src_name = data.nodes[data.links[lid].idSource].name;
                const trgt_name = data.nodes[data.links[lid].idTarget].name;
                return { 'label': src_name + '--->' + trgt_name, 'value': lid };
            });
        }
        const content_slectlink_ref = react_1.default.createElement(react_bootstrap_1.Container, null,
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), maxW: '60%', isChecked: data.unit_link_value_display === 'value', onChange: () => {
                        data.unit_link_value_display = 'value';
                        set_data(Object.assign({}, data));
                    } }, t('view.unit_sankey_values_links'))),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), maxW: '60%', isChecked: data.unit_link_value_display === 'percent', onChange: () => {
                        data.unit_link_value_display = 'percent';
                        set_data(Object.assign({}, data));
                    } }, t('view.unit_sankey_percent_links'))),
            has_sector_ref_node_ins_unitary_view ? react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), maxW: '60%', isChecked: data.unit_link_value_display === 'normalize', onChange: () => {
                        data.unit_link_value_display = 'normalize';
                        set_selected_node_to_configure(data.unitary_node[0]);
                        set_data(Object.assign({}, data));
                    } }, t('view.unit_sankey_normalize_links'))) : react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement("hr", null),
            data.unit_link_value_display === 'normalize' ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '50%' } }, t('view.chose_node_to_configure')),
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { value: selected_node_to_configure, onChange: (evt) => {
                            set_selected_node_to_configure(evt.target.value);
                        } }, data.unitary_node
                        .filter(nid => data.nodes[nid].tags['Type de noeud'] && data.nodes[nid].tags['Type de noeud'].includes('secteur'))
                        .map(nid => {
                        return react_1.default.createElement("option", { value: data.nodes[nid].idNode }, data.nodes[nid].name);
                    }))),
                selected_node_to_configure && selected_node_to_configure !== 'None' ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '50%' } }, t('view.chose_io')),
                        react_1.default.createElement(react_bootstrap_1.Button, { style: { width: '25%' }, variant: search_in_input_or_output === 'inputLinksId' ? 'primary' : 'outline-primary', onClick: () => {
                                data.process_transfo_ref[selected_node_to_configure] = [];
                                set_search_in_input_or_output('inputLinksId');
                            } }, t('view.input_link')),
                        react_1.default.createElement(react_bootstrap_1.Button, { style: { width: '25%' }, variant: search_in_input_or_output === 'outputLinksId' ? 'primary' : 'outline-primary', onClick: () => {
                                data.process_transfo_ref[selected_node_to_configure] = [];
                                set_search_in_input_or_output('outputLinksId');
                            } }, t('view.output_link'))),
                    react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                        react_1.default.createElement(react_bootstrap_1.InputGroup.Text, { style: { width: '50%' } }, t('view.chose_link_ref')),
                        react_1.default.createElement("div", { style: { width: '50%' } },
                            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { className: 'multidropdown_select_link_ref', 
                                // style={{ width:'50%' }}
                                labelledBy: 'dropdown_link_filter', overrideStrings: {
                                    'selectAll': 'Tout sélectionner',
                                }, value: selected_id, options: option, onChange: (selected) => {
                                    data.process_transfo_ref[selected_node_to_configure] = [];
                                    selected.forEach(s => {
                                        data.process_transfo_ref[selected_node_to_configure].push(s.value);
                                    });
                                    set_data(Object.assign({}, data));
                                } })))) : react_1.default.createElement(react_1.default.Fragment, null)) : react_1.default.createElement(react_1.default.Fragment, null));
        const dragLayout = show_modal_edit_link_unitary_sankey[0] ? (0, SankeyMenuTop_1.MenuDraggable)(content_slectlink_ref, { current: [window.innerWidth / 4, window.innerHeight / 4] }, t('view.view_title_modal_select_link_ref_in_unitary_sankey'), show_modal_edit_link_unitary_sankey[1], 50) : react_1.default.createElement(react_1.default.Fragment, null);
        return dragLayout;
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.modal_unitary_sankey_sector_node = modal_unitary_sankey_sector_node;
const is_leaf = (data, kn) => {
    // Check if some nodes has kn for parent if yes then kn is not a leaf otherwise it is a leaf
    return Object.values(data.nodes).filter(n => {
        if (n.dimensions === undefined || Object.keys(n.dimensions).length === 0) {
            return false;
        }
        else {
            return (Object.entries(n.dimensions).filter(en => en[0] !== 'Primaire' && en[1].parent_name === kn).length > 0);
        }
    }).length === 0;
};
// Return a list of nodes formated to be used in FolderTree component, the tree reprensent the aggregation tree of nodes
// const tree_data_nodes=(t:TFunction,data:SankeyDevData,multi_selected_nodes:{current:SankeyDevNode[]},filter_node_selector:string[])=>{
//   const tree:treeFolderType={id:'root',name:t('Noeud.TS'),children:[]}
//   Object.values(data.nodes).filter(n=> check_node_has_node_type(n,filter_node_selector)).forEach(n=>{
//     const sub_tree={id:n.idNode,name:n.name} as treeFolderType
//     tree.children?tree.children.push(sub_tree):tree.children=[sub_tree]})
//   tree.children?.forEach(t=>{
//     const child_t=add_children(data.nodes,data.nodes[t.id],multi_selected_nodes,filter_node_selector)
//     if(child_t.length>0){
//       t.children=child_t
//     }
//   })
//   return tree
// }
// // Function to filter nodes that don't have parent
// const check_node_has_no_valid_dimensions=(n:SankeyDevNode)=>{
//   if(!n.dimensions){
//     return true
//   }
//   let invalid=true
//   Object.entries(n.dimensions).filter(nd=>nd[0]==='Primaire').forEach(value_dim=>{
//     if(value_dim[1].parent_name!==undefined){
//       invalid=false
//     }
//   })
//   return invalid
// }
// Banner to create unitary view
// It is similar to SankeyPlusBannerView but specialised in the creation of unitary view
// It contain :
// - a button to return to master_data
// - a button to create a unitary view after selecting a node in a tree-list
// - a button to open a modal where we import data from excel file then create unitary views after selecting nodes in a tree-list
// - a button to save the modification of the current view
// - 2 buttons to switch between views (even not unitary view)
// - a selector to switch view
// - a button to delete the current view
// - a button to open the modal used to select links for reference in the display of link value (only appear of the unitary node is a sector)
const SankeyDevBannerUnit = (data, set_data, view, set_view, master_data, set_master_data, multi_selected_nodes, t, connected, dict_hook_ref_setter_show_dialog_components, view_selector) => {
    const m_d = master_data ? master_data : data;
    const [show_modify_name_view, set_show_modify_name_view] = (0, react_1.useState)(false);
    const target_popover_modify_view_name = (0, react_1.useRef)(null);
    const target_node_selector = (0, react_1.useRef)(null);
    const [show_node_unitary_selector, set_show_node_unitary_selector] = (0, react_1.useState)(false);
    const has_node_type = Object.values(data.nodeTags).filter(t => t.group_name === 'Type de noeud').length > 0;
    const pre_filter_node = (has_node_type) ? Object.keys(data.nodeTags['Type de noeud'].tags) : [];
    const [filter_node_selector, set_filter_node_selector] = (0, react_1.useState)(pre_filter_node);
    const has_views = master_data ? master_data.view.length > 0 : false;
    const next_button_disabled = m_d.view && (m_d.view.map(d => d.id).indexOf(view) === m_d.view.length - 1);
    const prev_button_disabled = m_d.view && (m_d.view.map(d => d.id).indexOf(view) === 0 || view === 'none');
    //const tree_of_nodes=tree_data_nodes(t,data,multi_selected_nodes,filter_node_selector)
    const tree_of_nodes = {};
    // Overlay containing the tree of nodes
    const overlayNodeSlector = react_1.default.createElement(react_bootstrap_1.Overlay, { key: 'popover-nodes-level', placement: 'bottom', target: target_node_selector, rootClose: true, show: show_node_unitary_selector, onHide: () => { set_show_node_unitary_selector(false); } },
        react_1.default.createElement(react_bootstrap_1.Popover, { id: 'popover-creation_unitary_view', style: { maxWidth: '100%' } },
            react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('view.selectNodeForUnitaryView')),
            react_1.default.createElement(react_bootstrap_1.Popover.Body, { style: { maxHeight: '500px', overflowY: 'auto' } },
                has_node_type ? react_1.default.createElement(react_bootstrap_1.InputGroup, { style: { width: '100%' }, as: react_bootstrap_1.ButtonGroup },
                    pre_filter_node.includes('produit') ? react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: filter_node_selector.includes('produit') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!filter_node_selector.includes('produit')) {
                                filter_node_selector.push('produit');
                            }
                            else {
                                filter_node_selector.splice(filter_node_selector.indexOf('produit'), 1);
                            }
                            set_filter_node_selector(filter_node_selector);
                            set_data(Object.assign({}, data));
                        } }, t('Noeud.product')) : react_1.default.createElement(react_1.default.Fragment, null),
                    pre_filter_node.includes('secteur') ? react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: filter_node_selector.includes('secteur') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!filter_node_selector.includes('secteur')) {
                                filter_node_selector.push('secteur');
                            }
                            else {
                                filter_node_selector.splice(filter_node_selector.indexOf('secteur'), 1);
                            }
                            set_filter_node_selector(filter_node_selector);
                            set_data(Object.assign({}, data));
                        } }, t('Noeud.sector')) : react_1.default.createElement(react_1.default.Fragment, null),
                    pre_filter_node.includes('echange') ? react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: filter_node_selector.includes('echange') ? 'primary' : 'outline-primary', onClick: () => {
                            if (!filter_node_selector.includes('echange')) {
                                filter_node_selector.push('echange');
                            }
                            else {
                                filter_node_selector.splice(filter_node_selector.indexOf('echange'), 1);
                            }
                            set_filter_node_selector(filter_node_selector);
                            set_data(Object.assign({}, data));
                        } }, t('Noeud.exchange')) : react_1.default.createElement(react_1.default.Fragment, null)) : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_folder_tree_1.default, { iconComponents: {
                        FileIcon: SankeyUtils_1.FileIcon,
                        FolderIcon: SankeyUtils_1.FolderIcon,
                        FolderOpenIcon: SankeyUtils_1.FolderOpenIcon
                    }, showCheckbox: false, initCheckedStatus: 'custom', indentPixels: 20, onNameClick: ({ defaultOnClick, nodeData }) => {
                        defaultOnClick;
                        // Create a unitary sankey from the node selected
                        if (master_data === undefined) {
                            master_data = JSON.parse(JSON.stringify(data));
                        }
                        (0, exports.CreateViewNodeUnitary)(t, data, set_data, master_data, set_master_data, data.nodes[nodeData.id], set_view, data.nodes, data.links, false, '');
                        set_show_node_unitary_selector(false);
                    }, data: tree_of_nodes }))));
    // Button that open the overlay to select a unitary node
    const buttonCreateUnitaryView = react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'buttonCreateViewUnitaryDisabled', placement: 'bottom', delay: 500, overlay: (!connected) ? (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonCreateViewUnitaryDisabled' },
            t('Menu.sankeyPlusDisabled'),
            " ")) :
            react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonCreateViewUnitary' },
                t('view.tooltips.buttonCreateViewUnitary'),
                " ") },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', ref: target_node_selector, disabled: !connected, onClick: () => { set_show_node_unitary_selector(!show_node_unitary_selector); } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSquarePlus, style: { opacity: (!connected) ? '0.6' : '1' } })),
                !connected ?
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock, style: {
                                fontSize: '1em',
                                position: 'absolute',
                                right: '0.1em',
                                bottom: '0em',
                                color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                            } }))
                    : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Col, { style: { 'fontSize': '9px' } }, t('view.unit')))));
    // Button to display a modal where we chose refrence link in the unitary sankey (for more info look func modal_unitary_sankey_sector_node in SankeyDevNodes)
    const button_open_modal_unitary_sankey_sector_node = react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'unit_excel', placement: 'bottom', rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-unit_excel' },
            t('view.tooltips.choose_link_ref_sankey_unit'),
            " ") },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => dict_hook_ref_setter_show_dialog_components.ref_setter_show_modal_edit_link_reference_unitary.current(true) },
                react_1.default.createElement(react_bootstrap_1.Col, null, logo_unit_process_transfo),
                react_1.default.createElement(react_bootstrap_1.Col, { style: { 'fontSize': '9px', whiteSpace: 'break-spaces', lineHeight: '0.8' } }, t('view.choose_link_ref_sankey_unit')))));
    const button_delete_actual_view = react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'button_delete_actual_view', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'button_delete_actual_view' },
            t('view.tooltips.button_delete_actual_view'),
            " ") },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', disabled: !connected, onClick: 
                // Delete the view
                () => {
                    let ind = -1;
                    master_data.view.forEach((v, i) => {
                        ind = (v.id === view) ? i : ind;
                    });
                    master_data.view.splice(ind, 1);
                    // If master is not a catalog & we delete the current view then we go to master
                    // If master is a catalog and the catalog of view is empty then we got to master
                    if ((master_data.current_view === view && master_data.is_catalog === false) || (master_data.view.length === 0 && master_data.is_catalog === true)) {
                        set_view('none');
                        set_data(Object.assign({}, master_data));
                    }
                    else if (master_data.is_catalog && master_data.view.length > 0) {
                        // If master is a catalog and the catalog is not empty then we got to the first view
                        set_view(master_data.view[0].id);
                        const tmp = (0, SankeyPlusViews_1.GetDataFromView)(master_data, master_data.view[0].id);
                        set_data(Object.assign({}, tmp));
                    }
                    if (master_data.view.length === 0) {
                        master_data.is_catalog = false;
                        set_data(Object.assign({}, master_data));
                    }
                    set_master_data(Object.assign({}, master_data));
                } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(fa_2.FaMinus, null)),
                !connected ?
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock, style: {
                                fontSize: '1em',
                                position: 'absolute',
                                right: '0.1em',
                                bottom: '0em',
                                color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                            } }))
                    : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Col, { style: { 'fontSize': '9px', whiteSpace: 'break-spaces', lineHeight: '0.8' } }, t('view.delete')))));
    // Vutton to open a modal where we import data from excel (that are not drawn) so we can create unitary view from these files (without having the whole data)
    const button_open_modal_unit_view_from_excel = react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'unit_from_excel', placement: 'bottom', rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-unit_from_excel' },
            t('view.tooltips.unit_from_excel'),
            " ") },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', disabled: !connected, onClick: () => {
                    dict_hook_ref_setter_show_dialog_components.ref_setter_is_for_unitary_view.current(true);
                    dict_hook_ref_setter_show_dialog_components.ref_setter_show_unitary_view_modal.current(true);
                } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFileExcel })),
                !connected ?
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock, style: {
                                fontSize: '1em',
                                position: 'absolute',
                                right: '0.1em',
                                bottom: '0em',
                                color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                            } }))
                    : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Col, { style: { 'fontSize': '9px', whiteSpace: 'break-spaces', lineHeight: '0.8' } }, t('view.unit_from_excel')))));
    const popover_modify_view_name = react_1.default.createElement(react_bootstrap_1.Popover, { id: "popover-link-filter", style: { maxWidth: '100%', 'overflowY': 'auto' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('view.modify_name_view')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: 'text', value: master_data && master_data.current_view && master_data.current_view !== 'none' ? master_data.view.filter(v => v.id === master_data.current_view)[0].nom : '', onChange: (evt) => {
                    if (master_data) {
                        master_data.view.filter(v => v.id === master_data.current_view).forEach(v => v.nom = evt.target.value);
                    }
                    set_data(Object.assign({}, data));
                } })));
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Overlay, { key: 'popover-link-filter', placement: 'bottom', target: target_popover_modify_view_name, rootClose: true, show: show_modify_name_view, onHide: () => { set_show_modify_name_view(false); } }, popover_modify_view_name),
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'buttonHomeViewDisabled', placement: 'bottom', delay: 500, overlay: (!connected && !has_views) ?
                react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonHomeViewDisabled' },
                    t('Menu.sankeyPlusDisabled'),
                    " ") :
                react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonHme' },
                    t('view.tooltips.home'),
                    " ") },
            react_1.default.createElement("span", null,
                react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', disabled: ((!connected && !has_views) || (master_data && master_data.is_catalog)), onClick: () => {
                        const ev = document;
                        const tmp = { key: 'F7' };
                        if (ev.onkeydown) {
                            ev.onkeydown(tmp);
                        }
                    } },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(fa_1.FaHome, { style: { opacity: ((connected && has_views) && (master_data && !master_data.is_catalog)) ? '1' : '0.6' } })),
                    (!connected && !has_views) ?
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock, style: {
                                    fontSize: '1em',
                                    position: 'absolute',
                                    right: '0.1em',
                                    bottom: '0em',
                                    color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                } }))
                        : react_1.default.createElement(react_1.default.Fragment, null),
                    react_1.default.createElement(react_bootstrap_1.Col, { style: { 'fontSize': '9px' } }, t('Menu.home'))))),
        buttonCreateUnitaryView,
        overlayNodeSlector,
        button_open_modal_unit_view_from_excel,
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'buttonPrevViewDisabled', placement: 'bottom', delay: 500, overlay: (!connected && !has_views) ?
                react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonPrevViewDisabled' },
                    t('Menu.sankeyPlusDisabled'),
                    " ") :
                react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonPrevView' },
                    t('view.tooltips.PrevViewButton'),
                    " ") },
            react_1.default.createElement("span", null,
                react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', disabled: prev_button_disabled || !has_views, onClick: () => {
                        const ev = document;
                        const tmp = { key: 'F8' };
                        if (ev.onkeydown) {
                            ev.onkeydown(tmp);
                        }
                    } },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(fa_2.FaCaretSquareLeft, { style: { opacity: (prev_button_disabled || !has_views) ? '0.6' : '1' } })),
                    (!connected && !has_views) ?
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock, style: {
                                    fontSize: '1em',
                                    position: 'absolute',
                                    right: '0.1em',
                                    bottom: '0em',
                                    color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                } }))
                        : react_1.default.createElement(react_1.default.Fragment, null),
                    react_1.default.createElement(react_bootstrap_1.Col, { style: { 'fontSize': '9px' } }, t('Menu.precView'))))),
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'buttonNextViewDisabled', placement: 'bottom', delay: 500, overlay: (!connected && !has_views) ? (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonNextViewDisabled' },
                t('Menu.sankeyPlusDisabled'),
                " ")) :
                react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonNextView' },
                    t('view.tooltips.NextViewButton'),
                    " ") },
            react_1.default.createElement("span", null,
                react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', disabled: next_button_disabled || !has_views, onClick: () => {
                        const ev = document;
                        const tmp = { key: 'F9' };
                        if (ev.onkeydown) {
                            ev.onkeydown(tmp);
                        }
                    } },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(fa_2.FaCaretSquareRight, { style: { opacity: (next_button_disabled || !has_views) ? '0.6' : '1' } })),
                    (!connected && !has_views) ?
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faLock, style: {
                                    fontSize: '1em',
                                    position: 'absolute',
                                    right: '0.1em',
                                    bottom: '0em',
                                    color: 'rgba(var(--bs-info-rgb), var(--bs-bg-opacity))'
                                } }))
                        : react_1.default.createElement(react_1.default.Fragment, null),
                    react_1.default.createElement(react_bootstrap_1.Col, { style: { 'fontSize': '9px' } }, t('Menu.nextView'))))),
        view_selector,
        (master_data ? master_data : { view: [] }).view.length > 0 && master_data.current_view !== 'none' && !window.SankeyToolsStatic ? react_1.default.createElement(react_1.default.Fragment, null,
            button_delete_actual_view,
            data.unitary_node.length > 0 ? button_open_modal_unitary_sankey_sector_node : react_1.default.createElement(react_1.default.Fragment, null))
            : react_1.default.createElement(react_1.default.Fragment, null));
};
exports.SankeyDevBannerUnit = SankeyDevBannerUnit;
// // Recursive function used to return children ( and sub-children) of node in the creation of the tree-list of nodes
// const add_children=(nodes:{[x:string]:SankeyDevNode},n:SankeyDevNode,multi_selected_nodes:{current:SankeyDevNode[]},filter_node_selector:string[])=>{
//   const children:treeFolderType[]=[]
//   Object.entries(nodes)
//     .filter(n=>check_node_has_node_type(n,filter_node_selector))
//     .forEach(nn=>{
//       if(nn[1].dimensions){
//         Object.entries(nn[1].dimensions).filter(nd=>nd[0]==='Primaire' && nd[1].parent_name===n.idNode).forEach(()=>{
//           const c:treeFolderType={id:nn[0],name:nn[1].name}
//           const child=add_children(nodes,nn[1],multi_selected_nodes,filter_node_selector)
//           if(child.length!==0){
//             c.children=child
//           }
//           children.push(c)
//         })
//       }
//     })
//   return children
// }
const Modal_creation_view_unitary_from_data = ({ applicationContext, dict_variable_application_data, processFunctions, applicationDraw, convert_data, callback, dict_hook_ref_setter_show_dialog_components }) => {
    // selected_nodes_for_unitary_view is a list of nodes that is used to create unitary views we click on the button create
    const selected_nodes_for_unitary_view = (0, react_1.useRef)([]);
    const [is_for_unitary_view, set_is_for_unitary_view] = (0, react_1.useState)(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_is_for_unitary_view.current = set_is_for_unitary_view;
    const [excel_file_to_load, set_excel_file_to_load] = (0, react_1.useState)(undefined);
    const [file_name, set_file_name] = (0, react_1.useState)('');
    const [last_selected_file, set_last_selected_file] = (0, react_1.useState)();
    const [data_source_for_unitary, set_data_source_for_unitary] = (0, react_1.useState)({ 'none': dict_variable_application_data.get_default_data() });
    // Data from wich we will select nodes to create unitary views
    const [data_for_selection, set_data_for_selection] = (0, react_1.useState)(data_source_for_unitary['none']);
    const show_unitary_modal = (0, react_1.useState)(false);
    dict_hook_ref_setter_show_dialog_components.ref_setter_show_unitary_view_modal.current = show_unitary_modal[1];
    const data_default = data_source_for_unitary['none'];
    // Only take sector and product if it has 'Type de noeud' tag else all nodes are selectable
    const has_node_type = Object.values(data_for_selection.nodeTags).filter(t => t.group_name === 'Type de noeud').length > 0;
    const pre_filter_node = (has_node_type) ? Object.keys(data_for_selection.nodeTags['Type de noeud'].tags) : [];
    const [filter_node_selector, set_filter_node_selector] = (0, react_1.useState)(pre_filter_node);
    const [is_computing, set_is_computing] = (0, react_1.useState)(false);
    const key_nodes = Object.keys(data_for_selection);
    const tree_of_nodes = (0, SankeyMenuConfigurationNodes_1.tree_data_nodes)(applicationContext.t, data_for_selection, selected_nodes_for_unitary_view, key_nodes, filter_node_selector);
    //const tree_of_nodes = {} as {id: string,name: string,children: never[] }
    const local_launch = (path) => {
        processFunctions.path.current = path;
        processFunctions.ref_setter_processing.current(true);
        processFunctions.failure.current = true;
        processFunctions.not_started.current = false;
        processFunctions.ref_result.current('');
    };
    // Process data received after loading the excel file in the server
    if (is_for_unitary_view && !processFunctions.not_started.current && !processFunctions.ref_processing.current) {
        const path = window.location.href;
        const url = path + applicationContext.url_prefix + 'loads_retrieves_result';
        const form_data = new FormData();
        const fetchData = {
            method: 'POST',
            body: form_data
        };
        fetch(url, fetchData).then(response => {
            response.text().then(text => {
                try {
                    const server_data = JSON.parse(text);
                    let default_nstyle = data_default.style_node['default'];
                    let default_lstyle = data_default.style_link['default'];
                    server_data.h_space = data_default.h_space;
                    server_data.v_space = data_default.v_space;
                    default_nstyle = JSON.parse(JSON.stringify(data_default.style_node['default']));
                    default_lstyle = JSON.parse(JSON.stringify(data_default.style_link['default']));
                    const new_data = Object.assign(dict_variable_application_data.get_default_data(), server_data);
                    (0, FunctionOSTyped_1.ProcessExample)(server_data, applicationDraw.updateLayout, convert_data, () => null, dict_variable_application_data.get_default_data);
                    new_data.style_node['default'] = default_nstyle;
                    new_data.style_link['default'] = default_lstyle;
                    callback(new_data);
                    delete new_data.layout;
                    // Add the loaded excel to the list of data used in the modale that create unit view from excel file
                    data_source_for_unitary[file_name] = new_data;
                    if (last_selected_file === undefined) {
                        set_last_selected_file(file_name);
                        set_data_for_selection(new_data);
                    }
                    set_data_source_for_unitary(Object.assign({}, data_source_for_unitary));
                }
                catch (err) {
                    alert(err);
                }
            }).then(() => {
                set_is_computing(false);
            });
        });
        processFunctions.ref_processing.current = false;
        processFunctions.failure.current = false;
        processFunctions.not_started.current = true;
    }
    // Icon About state of excel process
    const spinner = (processFunctions.ref_processing.current || is_computing) ? react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border" }) : react_1.default.createElement(react_1.default.Fragment, null);
    const load_error = (!processFunctions.ref_processing.current && processFunctions.failure.current) ? react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: 'danger' },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { fontVariant: 'primary', icon: free_solid_svg_icons_1.faCircleExclamation })) : react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: show_unitary_modal[0], onHide: () => {
            set_is_for_unitary_view(false);
            show_unitary_modal[1](false);
        }, style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, applicationContext.t('view.create_unit'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement("h3", null,
                applicationContext.t('view.select_excel_file'),
                " ",
                spinner,
                " ",
                load_error),
            processFunctions.ref_processing.current ? (react_1.default.createElement(SankeyPersistence_1.Counter, { url_prefix: applicationContext.url_prefix, finishReconciliation: () => {
                    processFunctions.ref_processing.current = false;
                    set_is_computing(true);
                    processFunctions.failure.current = false;
                }, value: [1, 2, 3], result: processFunctions.ref_result.current })) : react_1.default.createElement(react_1.default.Fragment, null),
            react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", accept: '.xlsx,.xlsm,.xls', onChange: (evt) => {
                        if (evt.target.files.length > 0) {
                            set_file_name(evt.target.files[0].name);
                            set_excel_file_to_load(evt.target.files[0]);
                        }
                        else {
                            set_file_name('');
                            set_excel_file_to_load(undefined);
                        }
                    } })),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", disabled: excel_file_to_load === undefined, onClick: () => {
                    if (excel_file_to_load) {
                        local_launch('');
                        // Upldoad excel to server for process
                        const root = window.location.href;
                        const url = root + applicationContext.url_prefix + 'sankey/upload_excel';
                        const form_data = new FormData();
                        form_data.append('file', excel_file_to_load);
                        const fetchData = {
                            method: 'POST',
                            body: form_data
                        };
                        fetch(url, fetchData);
                    }
                } }, applicationContext.t('Menu.ouvrir')),
            Object.keys(data_source_for_unitary).filter(k => k !== 'none').length > 0 ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("hr", null),
                react_1.default.createElement(react_bootstrap_1.InputGroup, null,
                    react_1.default.createElement(react_bootstrap_1.InputGroup.Text, null, applicationContext.t('view.select_data_source')),
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { value: last_selected_file, onChange: (evt) => {
                            selected_nodes_for_unitary_view.current = [];
                            set_last_selected_file(evt.target.value);
                            set_data_for_selection(data_source_for_unitary[evt.target.value]);
                        } }, Object.entries(data_source_for_unitary).filter(([k,]) => k !== 'none').map(([k,]) => react_1.default.createElement("option", { key: k, value: k }, k))),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", disabled: !last_selected_file || last_selected_file === 'none', onClick: () => {
                            if (last_selected_file && last_selected_file !== 'none') {
                                delete data_source_for_unitary[last_selected_file];
                                set_data_source_for_unitary(data_source_for_unitary);
                                selected_nodes_for_unitary_view.current = [];
                                if (Object.keys(data_source_for_unitary).length > 1) {
                                    const first_file_of_list = Object.keys(data_source_for_unitary)[1];
                                    set_last_selected_file(first_file_of_list);
                                    set_data_for_selection(data_source_for_unitary[first_file_of_list]);
                                }
                                else {
                                    set_last_selected_file(undefined);
                                    set_data_for_selection(data_source_for_unitary['none']);
                                }
                            }
                        } },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan }))),
                react_1.default.createElement(react_bootstrap_1.Row, { style: { maxHeight: '500px', overflowY: 'auto' } },
                    has_node_type ? react_1.default.createElement(react_bootstrap_1.InputGroup, { style: { width: '100%' }, as: react_bootstrap_1.ButtonGroup },
                        pre_filter_node.includes('produit') ? react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: filter_node_selector.includes('produit') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!filter_node_selector.includes('produit')) {
                                    filter_node_selector.push('produit');
                                }
                                else {
                                    filter_node_selector.splice(filter_node_selector.indexOf('produit'), 1);
                                }
                                set_filter_node_selector(filter_node_selector);
                                dict_variable_application_data.set_data(Object.assign({}, dict_variable_application_data.data));
                            } }, applicationContext.t('Noeud.product')) : react_1.default.createElement(react_1.default.Fragment, null),
                        pre_filter_node.includes('secteur') ? react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: filter_node_selector.includes('secteur') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!filter_node_selector.includes('secteur')) {
                                    filter_node_selector.push('secteur');
                                }
                                else {
                                    filter_node_selector.splice(filter_node_selector.indexOf('secteur'), 1);
                                }
                                set_filter_node_selector(filter_node_selector);
                                dict_variable_application_data.set_data(Object.assign({}, dict_variable_application_data.data));
                            } }, applicationContext.t('Noeud.sector')) : react_1.default.createElement(react_1.default.Fragment, null),
                        pre_filter_node.includes('echange') ? react_1.default.createElement(react_bootstrap_1.Button, { className: 'btn_menu_config', variant: filter_node_selector.includes('echange') ? 'primary' : 'outline-primary', onClick: () => {
                                if (!filter_node_selector.includes('echange')) {
                                    filter_node_selector.push('echange');
                                }
                                else {
                                    filter_node_selector.splice(filter_node_selector.indexOf('echange'), 1);
                                }
                                set_filter_node_selector(filter_node_selector);
                                dict_variable_application_data.set_data(Object.assign({}, dict_variable_application_data.data));
                            } }, applicationContext.t('Noeud.exchange')) : react_1.default.createElement(react_1.default.Fragment, null)) : react_1.default.createElement(react_1.default.Fragment, null),
                    react_1.default.createElement(react_folder_tree_1.default, { iconComponents: {
                            FileIcon: SankeyUtils_1.FileIcon,
                            FolderIcon: SankeyUtils_1.FolderIcon,
                            FolderOpenIcon: SankeyUtils_1.FolderOpenIcon
                        }, initCheckedStatus: 'custom', indentPixels: 20, onNameClick: ({ defaultOnClick }) => {
                            // For now nothing happen when we click on node name
                            defaultOnClick;
                        }, data: tree_of_nodes, onChange: (state, event) => {
                            // This onChange event add or delete nodes to  selected_nodes_for_unitary_view
                            const ev = event;
                            const root_is_checked = Object.values(data_for_selection.nodes).filter(n => (0, SankeyMenuConfigurationNodes_1.check_node_has_node_type)(n, filter_node_selector)).map(n => n).length === selected_nodes_for_unitary_view.current.length;
                            if (state.checked === 0.5) {
                                state.checked = 0;
                            }
                            if (ev.path && ev.path.length > 0 && ev.type === 'checkNode') {
                                // check or uncheck node in tree folder depending on if it's already selected
                                const idNodeSelected = (0, SankeyMenuConfigurationNodes_1.getNodeFromTree)(ev.path, tree_of_nodes);
                                if (idNodeSelected.checked !== 0.5) {
                                    const newNodeSelected = data_for_selection.nodes[idNodeSelected.id];
                                    if (ev.params[0] === 1) {
                                        selected_nodes_for_unitary_view.current.push(newNodeSelected);
                                    }
                                    else {
                                        selected_nodes_for_unitary_view.current.splice(selected_nodes_for_unitary_view.current.indexOf(newNodeSelected), 1);
                                    }
                                }
                                set_data_for_selection(Object.assign({}, data_for_selection));
                            }
                            else if (ev.type === 'checkNode' && ev.path && ev.path.length === 0 && state.checked === 1 && !root_is_checked) {
                                // select all nodes
                                selected_nodes_for_unitary_view.current = Object.values(data_for_selection.nodes).filter(n => (0, SankeyMenuConfigurationNodes_1.check_node_has_node_type)(n, filter_node_selector)).map(n => n);
                                set_data_for_selection(Object.assign({}, data_for_selection));
                            }
                            else if (ev.type === 'checkNode' && ev.path && ev.path.length === 0 && state.checked === 0 && root_is_checked) {
                                // Deselect all nodes
                                selected_nodes_for_unitary_view.current = [];
                                set_data_for_selection(Object.assign({}, data_for_selection));
                            }
                        } }))) : react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'danger', onClick: () => {
                    show_unitary_modal[1](false);
                } }, applicationContext.t('Menu.close')),
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'primary', disabled: selected_nodes_for_unitary_view.current.length === 0, onClick: () => {
                    if (dict_variable_application_data.master_data === undefined) {
                        dict_variable_application_data.master_data = JSON.parse(JSON.stringify(dict_variable_application_data.data));
                    }
                    selected_nodes_for_unitary_view.current.forEach(n => {
                        (0, exports.CreateViewNodeUnitary)(applicationContext.t, data_for_selection, dict_variable_application_data.set_data, dict_variable_application_data.master_data, dict_variable_application_data.set_master_data, n, dict_variable_application_data.set_view, data_for_selection.nodes, data_for_selection.links, false, '');
                    });
                } }, applicationContext.t('view.create')))));
};
exports.Modal_creation_view_unitary_from_data = Modal_creation_view_unitary_from_data;
// Function that add some information in the legend about how we display links values :
// - Either with the raw value
// - Either as a percent comparing to the sum of input or output links value
// - Either as a value normalized by the value of one or more link linked the the unitary node
const SankeyDev_legend_elements = (t, data) => {
    var _a;
    const dev_data = data;
    const wrap = (0, d3_textwrap_1.textwrap)()
        .bounds({ height: 100, width: data.legend_width - 40 })
        .method('tspans');
    const g_legend = d3.select(' .opensankey #g_legend g');
    let shift_y = 0;
    shift_y += data.legend_police + 2;
    g_legend.append('text')
        .attr('transform', 'translate(0, ' + shift_y + ' )')
        .attr('style', 'font-style:italic;font-size:' + (data.legend_police) + 'px')
        .text(() => {
        if (dev_data.unit_link_value_display === 'value') {
            return t('view.legend_unit_sankey_values_links');
        }
        else if (dev_data.unit_link_value_display === 'percent') {
            return t('view.legend_unit_sankey_percent_links');
        }
        else if (dev_data.unit_link_value_display === 'normalize') {
            return t('view.legend_unit_sankey_normalize_links');
        }
        return '';
    });
    shift_y += data.legend_police + 2;
    if (dev_data.unit_link_value_display === 'normalize') {
        Object.entries(dev_data.process_transfo_ref).filter(d => d[1].length > 0).forEach(d => {
            g_legend.append('text')
                .attr('transform', 'translate(0, ' + shift_y + ' )')
                .text(data.nodes[d[0]].name + ' : ' + d[1].map(lid => data.nodes[data.links[lid].idSource].name + '-->' + data.nodes[data.links[lid].idTarget].name).join(', '))
                .call(wrap);
            shift_y += data.legend_police + 2;
        });
    }
    let h = (_a = document.getElementById('g_legend')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
    h = h ? h : 50;
    d3.select('#g_legend .drag_zone_leg').attr('height', h);
};
exports.SankeyDev_legend_elements = SankeyDev_legend_elements;
